/**
 * Token-less SDK source shown in the builder file tree (read-only, display only).
 * The builder has no message listener, so no token is needed here.
 *
 * Usage inside a code widget:
 *   import { submitQuery, viewProfile } from '/host-actions';
 */
export const HOST_ACTIONS_SDK_CODE = `
/**
 * Submit a chat question to the host app.
 * Clears the current page and starts a new chat session with the given query.
 * @param {string} query — the question text to submit
 */
export function submitQuery(query) {
  window.parent.postMessage(
    { type: 'host-action', action: 'submitQuery', payload: { query } },
    '*'
  );
}

/**
 * Navigate to a profile in the host app.
 * Clears the current page and starts a new chat session scoped to the profile.
 * @param {string} profileId — the profile identifier
 * @param {string} name — display name of the profile
 */
export function viewProfile(profileId, name) {
  window.parent.postMessage(
    { type: 'host-action', action: 'viewProfile', payload: { profileId, name } },
    '*'
  );
}
`;

/**
 * Generates the /host-actions.js SDK code with a per-instance capability token
 * embedded. The host message listener rejects any message whose token does not
 * match, preventing other iframes or scripts from spoofing actions.
 */
export function buildHostActionsSdkCode(token: string): string {
  return `
const __CAPABILITY_TOKEN__ = ${JSON.stringify(token)};

/**
 * Submit a chat question to the host app.
 * Clears the current page and starts a new chat session with the given query.
 * @param {string} query — the question text to submit
 */
export function submitQuery(query) {
  window.parent.postMessage(
    { type: 'host-action', action: 'submitQuery', token: __CAPABILITY_TOKEN__, payload: { query } },
    '*'
  );
}

/**
 * Navigate to a profile in the host app.
 * Clears the current page and starts a new chat session scoped to the profile.
 * @param {string} profileId — the profile identifier
 * @param {string} name — display name of the profile
 */
export function viewProfile(profileId, name) {
  window.parent.postMessage(
    { type: 'host-action', action: 'viewProfile', token: __CAPABILITY_TOKEN__, payload: { profileId, name } },
    '*'
  );
}
`;
}
